import MapSection from './MapSection.view';

export default MapSection;
